import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Modal from '../components/lib/Modal';
import GlassCard from '../components/lib/GlassCard';

import { PhoneNumberInput, Button } from 'hosman-material';

import USER from '../../../../../api/ressources/App/user';
import RADAR_LEADS from '../../../../../api/ressources/App/radarLeads';
import { updatePhoneNumberModalOpen, updateRadarLeadsCount } from '../../../../../reducers/_Pages/Public/radarSlice';
import { getUser } from '../../../../../reducers/App/userSlice';

const PhoneNumberModal = () => {
  const { user } = useSelector((state) => state.user);  
  const { phoneNumberModalOpen, modalPropertyId } = useSelector((state) => state.radar);
  const [lead, setLead] = useState({ phone_country_code: 'FR', phone_number: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    setErrors({ phone_country_code: 'FR', phone_number: '' })
  }, [phoneNumberModalOpen, lead]);

  useEffect(() => {
    setLead({ phone_country_code: user.phone_country_code || 'FR', phone_number: user.phone_number || '' })
  }, [user]);

  const submit = async() => {
    if (!lead.phone_number) {
      setErrors({ phone_number: ['*Veuillez entrer votre numéro de téléphone'] })
      return;
    }
    setIsSubmitting(true);
    let response;

    try {
      response = await USER.updateUser(lead);

      dispatch(getUser());
      dispatch(updatePhoneNumberModalOpen(false));
      createRadarLead();
    } catch (error) {
      setErrors(error.response.data?.error?.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const createRadarLead = async() => {
    const response = await RADAR_LEADS.createRadarLead({ property_id: modalPropertyId })

    dispatch(updateRadarLeadsCount(response.data.radar_leads_count));
  };

  return (
    <Modal isOpen={phoneNumberModalOpen} closeModal={() => dispatch(updatePhoneNumberModalOpen(false))}>
      <GlassCard hoverBgColor='' width='w-full md:w-96'>
        <div className='flex flex-col gap-6 p-4 text-center'>
          <div className='flex flex-col gap-3'>
            <p className='h3'>Merci pour votre intérêt pour le radar !</p>
            <p>Si vous souhaitez accéder à davantage de prix de biens récemment vendus par Hosman, il vous suffit de laisser votre numéro de téléphone.</p>
            <p>Un de nos agents du secteur prendra rapidement contact avec vous afin de vous communiquer toutes les informations utiles et répondre à vos questions.</p>
          </div>

          <div className='flex flex-col gap-12'>
            <PhoneNumberInput
              name='phone_number'
              label=''
              onChangePhone={(val) => setLead({ ...lead, phone_number: val })}
              onChangeCountryCode={(val) => setLead({ ...lead, phone_country_code: val })}
              phoneValue={lead.phone_number}
              countryCodeValue={lead.phone_country_code}
              errors={errors}
            />

            <Button label='Valider' onClick={() => submit()} isLoading={isSubmitting} />
          </div>
        </div>
      </GlassCard>
    </Modal>
  )
}

export default PhoneNumberModal;
